export interface UserData {
  firstName: string;
  lastName: string;
}

export interface UserLevel {
  levelId: number;
  levelName: string;
}

export interface DelegatedTeam {
  studentId: number;
  teamName: string;
  modules: DelegatedTeamModule[];
}

export class DelegatedTeamModule {
  moduleId: number;

  /**19 Perfomance objectives,
    25 Learningpaths
    29 LMS,
    32 Qualifications,
    41 Skillsmatrix,
    42 Development Objectives,
    51 Conversations */
  crmModuleIds: string;
}

export interface CoupledEmployee {
  studentId: number;
  firstName: string;
  lastName: string;
  functionName: string;
  departmentName: string;
  isManager: boolean;
}

export interface StudentRoleSettings {
  userId?: number;
  studentId?: number;
  level: UserLevelEnum;
  trainerId?: number;
  localHrId?: number;
  corporateHrId?: number;
  isManager: boolean;
  isMatrixManager: boolean;
  delegatedTeams: DelegatedTeam[];
  coupledEmployees: CoupledEmployee[];
  defaultLevel?: number;
}

export enum UserLevelEnum {
  None = 1,
  CorporateHr = 2,
  LocalHr = 4,
  Employee = 8,
  Candidate = 16,
  TrainingAdmin = 32,
  Trainer = 64,
  ExternalPartner = 128,
  TrainingProvider = 256,
  InterimHr = 512,
  MatrixManager = 1024,
  Manager = 999,
  Delegate = 1000,
}
